export default __webpack_public_path__ + "media/zurb/img/home/natgeo-logo-f9e32c6feee69efdcd575855c936db5f.png";